import { Form, Input, message } from 'antd';
import React from 'react';
import superagent from 'superagent';
import { BACKEND_API_URL } from '../../utils/constants';
import { withRouter } from '../../utils/router'

class RegisterForm extends React.Component {
    formRef = React.createRef();
    state = {
        focusItem: -1
    }
    registerSubmit = (values) => {
        this.setState({
            focusItem: -1
        })
        this.registerAsync(values.registerUsername, values.registerPassword)
    }

    registerAsync(username, password) {
        that = this;
        function callback(error, response) {
            if (!error && (response.statusCode === 401 || response.statusCode === 403)) {
                message.error('系统错误');
            } else if (!error && response.statusCode === 200) {
                const jsonRes = JSON.parse(response.text);
                if (jsonRes.code === 0) {
                    message.success("注册成功");
                    that.goBackLogin(goBackLogin);
                } else {
                    message.error(jsonRes.info);
                }
            } else {
                message.error("网络错误");
            }
        }

        superagent.post(BACKEND_API_URL.USER_REGISTER_URL).send({ 'name': username, 'password': password })
            .withCredentials()
            .set('Accept', 'application/json')
            //.set('Content-Type', 'multipart/form-data')
            .end(callback);
    }

    goBackLogin = () => {
        this.props.switchShowBox('login')
        setTimeout(() => this.formRef.current.resetFields(), 500)
    }

    goBackHome = () => {
        this.props.router.navigate('/')
    }

    render() {
        const { focusItem } = this.state
        return (
            <div className={this.props.className}>
                <div style={styles.logo} onClick={this.goBackHome}>
                    <span style={{ lineHeight: "40px", fontSize: "20px" }}>元纹</span>
                </div>
                <h3 className='title'>用户注册</h3>
                <Form onFinish={this.registerSubmit} ref={this.formRef}>
                    <Form.Item
                        name="registerUsername"
                        validateFirst={true}
                        rules={[
                            { required: true, message: '用户名不能为空' },
                            { pattern: '^[^ ]+$', message: '不能输入空格' },
                        ]}>
                        <Input
                            onFocus={() => this.setState({ focusItem: 0 })}
                            onBlur={() => this.setState({ focusItem: -1 })}
                            maxLength={16}
                            placeholder='用户名'
                            autoComplete='on'
                            addonBefore={<span className='iconfont icon-User' style={focusItem === 0 ? styles.focus : {}} />} />
                    </Form.Item>
                    <Form.Item
                        name="registerPassword"
                        validateFirst={true}
                        rules={[
                            { required: true, message: '密码不能为空' },
                            { pattern: '^[^ ]+$', message: '密码不能有空格' }
                        ]}>
                        <Input
                            onFocus={() => this.setState({ focusItem: 1 })}
                            onBlur={() => this.setState({ focusItem: -1 })}
                            type='password'
                            maxLength={16}
                            placeholder='密码'
                            autoComplete='on'
                            addonBefore={<span className='iconfont icon-suo1' style={focusItem === 1 ? styles.focus : {}} />} />
                    </Form.Item>
                    <Form.Item
                        name="confirmPassword"
                        validateFirst={true}
                        rules={[
                            { required: true, message: '请确认密码' },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue('registerPassword') === value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error('两次密码输入不一致!'));
                                },
                            }),
                        ]}>
                        <Input
                            onFocus={() => this.setState({ focusItem: 2 })}
                            onBlur={() => this.setState({ focusItem: -1 })}
                            type='password'
                            maxLength={16}
                            placeholder='确认密码'
                            autoComplete='on'
                            addonBefore={<span className='iconfont icon-suo1' style={focusItem === 2 ? styles.focus : {}} />} />
                    </Form.Item>
                    <div className='bottom'>
                        <input className='loginBtn' type="submit" value='注册' />
                        <span className='registerBtn' onClick={this.goBackLogin}>返回登录</span>
                    </div>
                </Form>
                <div className='footer'>
                    <div>亲爱的，欢迎加入我们！</div>
                </div>
            </div>
        )
    }
}

const styles = {
    focus: {
        // transform: 'scale(0.7)',
        width: '20px',
        opacity: 1
    },
    logo: {
        height: '50px',
        margin: '10px 0 30px 0',
        color: '#ffffff',
        padding: '4px',
        fontWeight: 'bold',
        textAlign: 'center',
        cursor: 'pointer',
        borderBottom: '1px solid #4444ff'
    },
}

export default withRouter(RegisterForm)